import React from 'react';
import { FaCloudUploadAlt, FaRegFileAlt } from 'react-icons/fa';

const orangeSelectedStyle = {
  background: '#fff7e6',
  color: '#d48806',
  border: '1.5px solid #faad14',
  fontWeight: 600,
};

const mergedStyle = {
  background: '#FFE5B4',
  borderLeft: '6px solid #FFA500',
  borderTop: '1.5px solid #FFA500',
  borderBottom: '1.5px solid #FFA500',
  borderRight: '1.5px solid #FFA500',
  color: '#b26a00',
  fontWeight: 600,
};

const POList = ({ data, selectedId, onSelect, selectedPOIds = [], onPOCheck, onPOUploadIconClick, onPODocumentView, mergedPOIds = [], poNumbersWithDocs = [], isShipmentClosed = false }) => {
  
  
  
  // Group merged POs at the top, in the order of mergedPOIds
  let sortedData = data;
  if (mergedPOIds && mergedPOIds.length > 0) {
    const merged = mergedPOIds
      .map(id => data.find(po => po.poReceivingID === id))
      .filter(Boolean);
    const unmerged = data.filter(po => !mergedPOIds.includes(po.poReceivingID));
    sortedData = [...merged, ...unmerged];

  }
  return (
    <div className="list-group">
      {/* <h5 className="mb-3">All Purchase Orders</h5> */}
      {sortedData.map(po => {
        const isMerged = mergedPOIds.includes(po.poReceivingID);
        const isSelected = selectedId === po.poReceivingID;

        return (
          <a
            href="#"
            key={po.poReceivingID}
            className={`list-group-item list-group-item-action d-flex align-items-center ${isShipmentClosed ? 'disabled' : ''}`}
            style={isSelected ? orangeSelectedStyle : isMerged ? mergedStyle : {}}
            onClick={e => { 
              e.preventDefault(); 
              if (!isShipmentClosed) {
                onSelect(po.poReceivingID); 
              }
            }}
          >
            <span className="flex-grow-1">
              {po.poNumber || po.poReceivingID}
              {isShipmentClosed && (
                <span className="badge bg-secondary ms-2">Read Only</span>
              )}
            </span>
            {!isShipmentClosed && (
              <input
                type="checkbox"
                className="form-check-input ms-2"
                checked={selectedPOIds.includes(po.poReceivingID)}
                onChange={e => {
                  e.stopPropagation();
                  onPOCheck && onPOCheck(po.poReceivingID, e.target.checked);
                }}
                style={{
                  cursor: 'pointer',
                  width: 20,
                  height: 20,
                  border: '2px solid #faad14',
                  borderRadius: 4
                }}
                onClick={e => e.stopPropagation()}
              />
            )}
            {/* Upload or Document icon */}
            {poNumbersWithDocs.includes(po.poNumber) && (
              <span
                className="ms-2"
                style={{ color: '#28a745', fontSize: 20, cursor: 'pointer' }}
                title="View PO Document"
                onClick={e => {
                  e.stopPropagation();
                  if (onPODocumentView) {
                    onPODocumentView(po);
                  }
                }}
              >
                <FaRegFileAlt />
              </span>
            )}
            {!isShipmentClosed && (
              <span
                className="ms-2"
                style={{ cursor: 'pointer', color: '#faad14', fontSize: 20 }}
                title="Upload PO Document"
                onClick={e => {
                  e.stopPropagation();
                  onPOUploadIconClick && onPOUploadIconClick(po.poReceivingID);
                }}
              >
                <FaCloudUploadAlt />
              </span>
            )}
          </a>
        );
      })}
    </div>
  );
};

export default POList;
